// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6hWgR","type":"styles_type__ebfhZ","choices":"styles_choices__3tYdq"};